import styles from 'css/SquareBox.module.css'
import Lib from 'library'

const SquareBox = ({ className, children, onClick, style }) => {

	const _class = Lib.getStyle(className, styles)

	return (
		<div style={style} className={`cmm-box ${_class}`} onClick={onClick}>
			{ children }
		</div>
	)
}

export default SquareBox
